import { Injectable } from '@angular/core';
import { AlertService } from './alert.service';

@Injectable({
  providedIn: 'root'
})
export class JsonHandlerService {
  isJSONParsable(jsonString: string,type:string,layout:string): boolean|{} {
    try {
      JSON.parse(jsonString);

      return JSON.parse(jsonString);
    } catch (error) {
      this.alertService.openNotifyError(`The ${type} Json is not parsable for the ${layout} layout`)
      throw new Error('JSON parsing failed');

    }
  }
  constructor(private alertService:AlertService) { }
}
